import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import $ from "jquery";
import { loader_image } from "../_components/Imagepath";
import {MaterialReactTable} from 'material-react-table';
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import PropTypes from 'prop-types';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

import {

  MenuItem,
} from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
const CustomerProducts = () => {
  const [menu, setMenu] = useState(false);
  const [dataa, setDataa] = useState([]);
  useEffect(() => {
    axios
      .post(
        "/customerportal/products/listing",
        {},
        {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setDataa(response.data.data.products);
        }else{
        //  window.location.href = "/login";
        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 
 // ✅ Functional component for Details Cell
 const DetailsCell = ({  row }) => {
   return <a href={`/customerportal/products-view/${row.original.id}`}>{row.original.name}</a>;
 };
 // ✅ Define PropTypes for DetailsCell
 DetailsCell.propTypes = {
   renderedCellValue: PropTypes.string.isRequired,
   row: PropTypes.shape({
     original: PropTypes.shape({
       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       name: PropTypes.string.isRequired, // ✅ Add this line

     }).isRequired,
   }).isRequired,
 };
  const columns2 =
  [

    {
      header: 'Name',
      accessorFn: (row) => `${row.name}`,
      Cell: DetailsCell, // ✅ Assigning function directly (No inline)
    },
    {
      header: 'Product Type',
      accessorFn: (row) => `${(row.type)?row.type.title:""} `,
    },
 
   
   ];
  // const FichedePalletePDF = async (product) => {
  //   $("#loader-image1").removeClass('loader-hide');
  //   $("#loader-image1").addClass('loader-show');
  //   axios.get(`/customerportal/products/listing/pdf/${product.id}`, {
  //     responseType: 'blob',
  //   headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
  // }).then(response => {
  //     const blob = new Blob([response.data], { type: 'application/pdf' });
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //      const productName = product?.name?.trim() || 'product';
  //     const productType = product?.type?.name?.trim() || 'type';
  //     const fileName = `${productName} ${productType}.pdf`;
  //     link.download = fileName;
  //     link.click();
  //     $("#loader-image1").addClass('loader-hide');
  //       $("#loader-image1").removeClass('loader-show');
  // })
  // .catch(error => {
  //     console.error('Error downloading PDF:', error);
  // });

  // };

  const downloadPDF = async (product) => {
    if (product.file) {
      AWS.config.update({
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
        region: AWS_DEFAULT_REGION,
        signatureVersion: 'v4',
      });
  
      const s3 = new AWS.S3();
      const params = {
        Bucket: AWS_BUCKET,
        Key: product.file,
        Expires: 60 // expires in 60 seconds
      };
  
      // 1. Get the signed URL
      const signedUrl = s3.getSignedUrl('getObject', params);
  
      // 2. Trigger download using an <a> tag
      const link = document.createElement('a');
      link.href = signedUrl;
      link.setAttribute('download', product.file.split('/').pop()); // e.g., "invoice.pdf"
      link.setAttribute('target', '_blank'); // optional: open in new tab if needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("PDF file not found for this product.");
    }
  };
  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title"> Products</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/profile">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active"> Products
                    </li>
                  </ul>
                </div>
              
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                <div className="card card-table">
                  <div className="card-body" style={{padding:'20px'}}>
                  <div className="table-responsive">
                  <h5 className="card-title">Products</h5>

                       <div className="table-responsive">
                      <MaterialReactTable columns={columns2} data={dataa} 
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        renderRowActionMenuItems={({ row }) => [
                          //  <MenuItem key="view" onClick={() => FichedePalletePDF(row.original)}>
                          //     Download <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                          //   </MenuItem>,
                              <MenuItem key="view" onClick={() => downloadPDF(row.original)}>
                            Download Specs <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                          </MenuItem>

                         
                        ]}
                    />                     
                    </div>        

           

                    </div>
                
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerProducts;
